// extracted by mini-css-extract-plugin
module.exports = {"tags__description":"Tags-module--tags__description--VRjgx"};